NtechApp.ViewBusinessAccPhotos = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._lightBox = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._lightBox = new NtechApp.LightBox(me._$view.find(".photosGrid"));
        me._syncGridView(); 

        me._bindEvents();
    }

    this._bindEvents = function() {
    }

    this._unbindEvents = function() {
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ViewBusinessAccPhotos, {
    addPhoto: function(photoUrl, thumbUrl, photoId) {
        var html = "";

        html += '<a href="' + photoUrl + '" data-lightboxImage="e" data-modelId="' + photoId + '">';
        html += '   <div class="item">';
        html += '       <img class="photoImg" src="' + thumbUrl + '" />';
        html += '   </div>';
        html += '</a>';

        this._$view.find(".photosGrid").prepend($(html));
        this._syncGridView();
    },

    rmPhoto: function(modelId) {
        this._$view.find(".photosGrid [data-modelId='" + modelId + "']").remove();
        this._syncGridView();
    },

    _syncGridView: function() {
        var $photosGrid = this._$view.find(".photos");
        var $noPhotos = this._$view.find(".noPhotos");

        var photosCount = this._$view.find(".photosGrid [data-modelId]").length;
        if(photosCount == 0) {
            $photosGrid.css("display", "none");
            $noPhotos.css("display", "block");
        }
        else {
            $photosGrid.css("display", "block");
            $noPhotos.css("display", "none");
        }

        this._$view.find(".photosCount").text(photosCount);
    }
});